import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

import { GoogleOAuthProvider } from "@react-oauth/google";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="523392842152-1ee04mtjlmt6ks7g9gkg0htfs26gimqq.apps.googleusercontent.com">
  <App />
</GoogleOAuthProvider>
  </React.StrictMode>,
);

